import { isFetchCollectionResultSuccessful } from '@/entities/FetchResult'
import { getTimerUsersApiCall } from '@/entities/User/UserService'
import { reportError, reportMessage } from '@/helpers/errorReporting'
import { TypedDispatch } from '@/store'

import { setError, setIsLoading, setTimerUsers } from './usersReducer'

export const fetchTimerUsers = () => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError())

    try {
        const response = await getTimerUsersApiCall()

        if (! isFetchCollectionResultSuccessful(response)) {
            reportMessage('fetchTimerUsers', `fetchTimerUsers failed with status code ${response.status}`)

            dispatch(setError(response))

            return
        }

        dispatch(setTimerUsers(response.data))
    } catch (error) {
        reportError('fetchTimerUsers', error)
    }

    dispatch(setIsLoading(false))
}
